<template>
	<div class="max-w-4xl px-8 py-16 mx-auto">
		<h2 class="text-4xl sm:text-5xl text-center font-semibold">
			{{ $t('careers.title') }}
		</h2>
		<p
			v-if="showEmptyState"
			class="mt-4 text-center text-lg text-highlighted"
		>
			{{ $t('careers.empty-state-text') }}
		</p>
		<CareerWidget
			v-model="showEmptyState"
			class="m-4"
		/>
	</div>
</template>

<script setup lang="ts">
import { useStoryblokWithErrorReporting } from '@/composables/useStoryblok'
import {
	BASE_URL,
	COMPANY_NAME
} from '@/constants/index.js'
import { OG_IMAGE_DEFAULT } from '@/constants/og-image'

import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	useScope: 'global'
})
const { getStory } = useStoryblokWithErrorReporting()

const showEmptyState = ref(false)

useHead({
	title: t('careers.meta-title'),
	meta: [
		{ name: 'description',
			content: t('careers.meta-description', { COMPANY_NAME }) },
		{ name: 'url',
			content: `${BASE_URL}/careers` }
	],
	link: [
		{
			rel: 'icon',
			type: 'image/x-icon',
			href: '/favicons/favicon.ico'
		}
	]
})
const storyblok = await getStory('careers')
const { story } = storyblok.value?.data || {}

const {
	title, description
} = story?.content?.metatags || {
	title: t('careers.meta-title'),
	description: t('careers.meta-description')
}

useSeoMeta({
	title: () => title,
	ogTitle: () => title,
	description: () => description,
	ogDescription: () => description,
	ogUrl: () => BASE_URL,
	twitterTitle: () => title,
	twitterDescription: () => description,
	twitterImage: () => '/images/og-image-fallback.png',
	twitterCard: () => 'summary_large_image'
})

 import.meta.prerender && defineOgImage('Default', OG_IMAGE_DEFAULT)
</script>
